export type CourseStatus = 'completed' | 'inProgress' | 'upcoming';

export interface Course {
  title: string;
  start: string;
  end: string;
  duration: string;
  classroom: string;
  assistant: string;
  students: string;
  status: CourseStatus;
}

export interface Teacher {
  id: string;
  name: string;
  subject: string;
  status: CourseStatus | 'free';
  nextCourse?: string;
  courses: Course[];
}

export const teachers: Teacher[] = [
  {
    id: 'zhang', name: '张老师', subject: '数学', status: 'upcoming', nextCourse: '下一节 15:00 · 数学思维进阶 1 班',
    courses: [
      { title: '【2025】数学思维进阶 001', start: '10:00', end: '10:50', duration: '50 分钟', classroom: 'A201 教室', assistant: '王老师', students: '0/9 人', status: 'completed' },
      { title: '【2025】数学思维进阶 001', start: '10:00', end: '10:50', duration: '50 分钟', classroom: 'A201 教室', assistant: '—', students: '0/9 人', status: 'completed' },
      { title: '数学精英班 1 班', start: '15:00', end: '17:00', duration: '120 分钟', classroom: 'C301 教室', assistant: '常浩宇', students: '0/3 人', status: 'upcoming' },
    ],
  },
  { id: 'li', name: '李老师', subject: '英语', status: 'free', courses: [] },
  { id: 'wang', name: '王老师', subject: '语文', status: 'free', courses: [] },
  { id: 'chen', name: '陈老师', subject: '科学', status: 'inProgress', nextCourse: '进行中 · 科学实验 2 班', courses: [{ title: '科学实验 2 班', start: '13:30', end: '15:00', duration: '90 分钟', classroom: 'B102 教室', assistant: '—', students: '12/18 人', status: 'inProgress' }] },
  { id: 'lin', name: '林老师', subject: '美术', status: 'free', courses: [] },
  { id: 'zhao', name: '赵老师', subject: '舞蹈', status: 'free', courses: [] },
  { id: 'sun', name: '孙老师', subject: '音乐', status: 'free', courses: [] },
];
